import { useSelector } from 'react-redux';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@/shared/components/MaterialTableElements';
import { RootState } from '@/stores';

// Sort field ids MUST match the data accessor used by getSorting in the parent
// (it reads a[id]). lessonCount and isFlagship don't exist as plain props on
// Course — the parent's getSorting wrapper handles them via a custom accessor.
const rows = [
    { id: 'slug', disablePadding: true, label: 'Slug', sortable: true },
    { id: 'title', disablePadding: false, label: 'Title', sortable: true },
    { id: 'trackType', disablePadding: false, label: 'Track', sortable: true },
    { id: 'subscriptionPlan', disablePadding: false, label: 'Plan', sortable: true },
    { id: 'lessonCount', disablePadding: false, label: 'Lessons', sortable: true },
    { id: 'isFlagship', disablePadding: false, label: 'Flagship', sortable: true },
    { id: 'orderIndex', disablePadding: false, label: 'Order', sortable: true },
    { id: 'updated_at', disablePadding: false, label: 'Updated At', sortable: true },
];

interface MatTableHeadProps {
    onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
    order: 'asc' | 'desc';
    orderBy: string;
}

const MatTableHead = ({ order, orderBy, onRequestSort }: MatTableHeadProps) => {
    const rtl = useSelector((state: RootState) => state.rtl);

    return (
        <TableHead>
            <TableRow>
                {rows.map((row) => (
                    <TableCell
                        key={row.id}
                        align={rtl.direction === 'rtl' ? 'right' : 'left'}
                        padding={row.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === row.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === row.id}
                            direction={order}
                            onClick={(event) => onRequestSort(event, row.id)}
                            className="material-table__sort-label"
                            dir="ltr"
                        >
                            {row.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

export default MatTableHead;
